<div class="p-2 border rounded datastream">
  <div class="row">
    <div [class]="{ 'col-7': dataStream.logoImageUrl, 'pe-0': dataStream.logoImageUrl, col: !dataStream.logoImageUrl }">
      <strong class="d-block fw-semibold text-overflow">{{ dataStream.supplier?.attributes?.['NAME'] }}</strong>
      @if (dataStream.supplier! | identification : 'GLN') {
        <small class="d-block"><strong>GLN:</strong> {{ dataStream.supplier! | identification : "GLN" }}</small>
      }
      <small class="d-block"><strong>{{ "Template.RequestDataStreamComponent.label_products" | translate }}</strong> {{ dataStream.productCount || 0 | number }}</small>
    </div>

    @if (dataStream.logoImageUrl) {
      <div class="col-5 logo">
        <div class="text-end">
          @if (dataStream.logoImageUrl) {
            <img class="img-fluid" [src]="dataStream.logoImageUrl" />
          }
        </div>
      </div>
    }

    @if (dataStream.contactData) {
      <button (click)="showContact()" class="btn-link float-right">
        <fa-icon icon="comment"></fa-icon>
      </button>
    }
  </div>

  @if (dataStream.firstImportDate! < newMinDate) {
    <small class="d-block fw-bold text-danger text-uppercase">{{ "Template.RequestDataStreamComponent.text_new" | translate }}</small>
  }

  <button (click)="sendRequest()" class="btn btn-secondary btn-sm d-block w-100 mt-2" [disabled]="sendingRequest || dataStream.statusId">
    <fa-icon icon="key" class="me-1"></fa-icon>
    @if (!dataStream.statusId) {
      <span>{{ "Template.RequestDataStreamComponent.btn_requestAccess" | translate }}</span>
    }
    @if (dataStream.statusId! == 'REQUESTED') {
      <span>{{ "Template.RequestDataStreamComponent.text_accessRequested" | translate }}</span>
    }
    @if (dataStream.statusId! == 'DENIED') {
      <span>{{ "Template.RequestDataStreamComponent.text_accessDenied" | translate }}</span>
    }
    @if (sendingRequest) {
      <fa-icon icon="spinner" class="ms-1" animation="spin"></fa-icon>
    }
  </button>
</div>

<ng-template #contactModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ "Template.RequestDataStreamComponent.subHeader_contactForData" | translate }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body pb-0">
    <p>{{ "Template.RequestDataStreamComponent.text_contactExplanation" | translate }}</p>
    @if (dataStream.contactData) {
      <div>
        <strong class="d-block">{{ "Template.RequestDataStreamComponent.label_contactPerson" | translate }}</strong>
        <div>
          {{ dataStream.contactData.firstName }}
          {{ dataStream.contactData.lastName }}
        </div>
        <div>
          {{ "Template.RequestDataStreamComponent.label_email" | translate }} <a href="mailto:{{ dataStream.contactData.email }}">{{ dataStream.contactData.email }}</a>
        </div>
        <div>{{ "Template.RequestDataStreamComponent.text_phone" | translate : { phone: dataStream.contactData.phone } }}</div>
      </div>
    }
  </div>
</ng-template>
